import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Input } from '@/shared/components/Input';
import { Button } from '@/shared/components/Button';
import { ApiError } from '@/lib/api-client';
import { useCreateTicket } from '../hooks/useSupport';
/** Opens a new technical incident. Calls `onCreated` with the new ticket id. */
export function NewTicketForm({ onCreated }) {
    const create = useCreateTicket();
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [error, setError] = useState(null);
    function submit(e) {
        e.preventDefault();
        if (subject.trim().length < 3) {
            setError('El asunto debe tener al menos 3 caracteres.');
            return;
        }
        if (body.trim().length < 10) {
            setError('Describe la incidencia (mínimo 10 caracteres).');
            return;
        }
        setError(null);
        create.mutate({ subject: subject.trim(), body: body.trim() }, {
            onSuccess: (thread) => onCreated(thread.ticket.id),
            onError: (e) => setError(e instanceof ApiError ? e.message : 'No se pudo crear la incidencia.'),
        });
    }
    return (_jsxs("form", { onSubmit: submit, className: "flex flex-col gap-4", noValidate: true, children: [_jsx(Input, { label: "Asunto", value: subject, onChange: (e) => setSubject(e.target.value), maxLength: 150, placeholder: "Resumen breve del problema" }), _jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("label", { htmlFor: "incident-body", className: "text-sm font-medium text-gray-700 dark:text-gray-300", children: "Descripci\u00F3n" }), _jsx("textarea", { id: "incident-body", value: body, onChange: (e) => setBody(e.target.value), rows: 5, maxLength: 4000, placeholder: "\u00BFQu\u00E9 ocurre? \u00BFEn qu\u00E9 pantalla? \u00BFDesde cu\u00E1ndo? Cuanto m\u00E1s detalle, antes lo resolvemos.", className: "resize-none rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand/50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100" })] }), error && (_jsx("p", { role: "alert", className: "text-sm text-red-600 dark:text-red-400", children: error })), _jsx(Button, { type: "submit", loading: create.isPending, className: "w-full", children: "Enviar incidencia" })] }));
}
//# sourceMappingURL=NewTicketForm.js.map